module.exports = __webpack_public_path__ + "img/contact.1a31073.png";